import { useState, useCallback } from "react";
import { GET_SWIMMING_LESSONS_EXERCISES } from "../../../../api/apiRoutes";
import { Exercise } from "../../../../models/Exercise";
import useApiRequest from "../../../../../utils/hooks/useApiRequest";
import useFacility from "../../../../../utils/hooks/useFacility";

export default function useSwimmingRecruitmentExercises() {
  const facilityIds = useFacility();
  const { get } = useApiRequest();
  const [exercises, setExercises] = useState<Exercise[]>([]);
  const [loading, setLoading] = useState(false);

  const getRecruitmentExercises = useCallback(
    async (exerciseName?: string) => {
      setLoading(true);
      const url = GET_SWIMMING_LESSONS_EXERCISES(facilityIds, exerciseName, undefined);
      const { result, isError } = await get(url);

      if (!isError && Array.isArray(result)) {
        setExercises(result);
      } else {
        setExercises([]);
      }
      setLoading(false);
    },
    [get, facilityIds],
  );

  return {
    getRecruitmentExercises,
    exercises,
    loading,
  };
}
